import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, StyledEngineProvider } from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';

// routing
import Routes from 'routes';

// defaultTheme
import themes from 'themes';

// project imports
import NavigationScroll from 'layout/NavigationScroll';
import { ToastContainer } from 'react-toastify';
import { listenForMessages } from './frebase/fmcToken&listner';
import { useNavigate } from 'react-router-dom';
import GlobalMoveResultModal from 'components/GlobalMoveResultModal';
import AppErrorBoundary from 'ui-component/AppErrorBoundary';

// ==============================|| APP ||============================== //

const App = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    // Start listening for messages
    listenForMessages(dispatch, navigate);

  }, [dispatch, navigate]);

  const customization = useSelector((state) => state.customization);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={themes(customization)}>
        <CssBaseline />
        <NavigationScroll>
          <AppErrorBoundary>
            <Routes />
          </AppErrorBoundary>
        </NavigationScroll>
      </ThemeProvider>
      <GlobalMoveResultModal />
      <ToastContainer />
    </StyledEngineProvider>
  );
};

export default App;
